export default {
    assets_url: process.env.VUE_APP_ASSETS_URL,
    api_url: process.env.VUE_APP_API_URL,
    facebook_app_id: process.env.VUE_APP_FB_ID,
    public_url: process.env.VUE_APP_WP_URL
};
